module.exports = __webpack_public_path__ + "img/banner_text_02.f7c32ad9.webp";